import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const NudgeSentIcon = createSvgIcon(
  'NudgeSentIcon',
  <>
    <circle cx="16" cy="16.5" r="16" fill={Color.Green300} />
    <path
      d="M13.0847 19.9676L9.29164 16.236L8 17.4978L13.0847 22.5L24 11.7617L22.7175 10.5L13.0847 19.9676Z"
      fill="white"
    />
  </>,
  { viewBox: '0 0 32 33', style: { height: '32px', width: '33px' } },
);
